module.exports = __webpack_public_path__ + "static/media/thomLukeSales.072d2be3.png";